import React from 'react';
import { FaExpandAlt, FaTimes, FaUserMd, FaSearch, FaStar, FaPaperPlane, FaCalendar } from 'react-icons/fa';

const AskADoctor = ({
  expandedContainer,
  onExpand,
  onClose,
  isExpandedInCenter,
}) => {
  const isExpanded = expandedContainer === 'askADoctor' || isExpandedInCenter;

  const renderCompactView = () => (
    <>
      <h4>Ask a Doctor</h4>
      <div className="quick-chat">
        <FaUserMd className="chat-icon" />
        <p>Connect with medical professionals</p>
      </div>
    </>
  );

  const renderExpandedView = () => (
    <div className="expanded-content">
      <h2>Medical Consultation Hub</h2>
      
      <div className="consultation-grid">
        <div className="chat-section">
          <div className="chat-header">
            <h3>Quick Question</h3>
            <p>Get answers from verified medical professionals</p>
          </div>
          
          <div className="message-thread">
            <div className="message received">
              <div className="message-avatar">
                <FaUserMd />
              </div>
              <div className="message-content">
                <div className="message-header">
                  <span className="name">Dr. Sarah Wilson</span>
                  <span className="badge">Cardiologist</span>
                </div>
                <p>Hello! How can I help you with your cardiology training today?</p>
                <span className="time">2:30 PM</span>
              </div>
            </div>

            <div className="message-input">
              <input type="text" placeholder="Type your medical question here..." />
              <button className="send-btn">
                <FaPaperPlane />
              </button>
            </div>
          </div>
        </div>

        <div className="doctors-section">
          <div className="search-box">
            <FaSearch className="search-icon" />
            <input type="text" placeholder="Search specialists..." />
          </div>

          <div className="doctors-list">
            <div className="doctor-card available">
              <div className="doctor-info">
                <div className="doctor-avatar">
                  <FaUserMd />
                  <span className="status-dot"></span>
                </div>
                <div>
                  <h4>Dr. Sarah Wilson</h4>
                  <p>Cardiology • St. Mary's</p>
                  <div className="rating">
                    <FaStar />
                    <span>4.9</span>
                    <span className="reviews">(124 reviews)</span>
                  </div>
                </div>
              </div>
              <button className="consult-btn">
                <FaCalendar />
                Available Now
              </button>
            </div>

            <div className="doctor-card">
              <div className="doctor-info">
                <div className="doctor-avatar">
                  <FaUserMd />
                  <span className="status-dot busy"></span>
                </div>
                <div>
                  <h4>Dr. James Chen</h4>
                  <p>Cardiology • Royal London</p>
                  <div className="rating">
                    <FaStar />
                    <span>4.8</span>
                    <span className="reviews">(98 reviews)</span>
                  </div>
                </div>
              </div>
              <button className="consult-btn secondary">
                <FaCalendar />
                Schedule
              </button>
            </div>

            <div className="doctor-card">
              <div className="doctor-info">
                <div className="doctor-avatar">
                  <FaUserMd />
                  <span className="status-dot busy"></span>
                </div>
                <div>
                  <h4>Dr. Emily Brown</h4>
                  <p>Cardiology • UCL</p>
                  <div className="rating">
                    <FaStar />
                    <span>4.7</span>
                    <span className="reviews">(156 reviews)</span>
                  </div>
                </div>
              </div>
              <button className="consult-btn secondary">
                <FaCalendar />
                Schedule
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div
      className={`info-box ask-doctor ${isExpandedInCenter ? 'center-expanded' : ''}`}
      style={{ display: 'none' }}
      aria-hidden="true"
      data-hidden="true"
    >
      {!isExpandedInCenter && (
        isExpanded ? (
          <button className="control-btn close" onClick={onClose} title="Close">
            <FaTimes size={12} />
          </button>
        ) : (
          <button className="control-btn expand" onClick={() => onExpand('askADoctor')} title="Expand">
            <FaExpandAlt size={12} />
          </button>
        )
      )}

      {isExpandedInCenter ? renderExpandedView() : renderCompactView()}

      <style jsx>{`
        .info-box {
          background: #fff;
          border-radius: 12px;
          padding: 1.5rem;
          position: relative;
          transition: all 0.3s ease;
        }

        // Compact view styles
        .quick-chat {
          display: flex;
          align-items: center;
          gap: 1rem;
          margin-top: 1rem;
          padding: 0.75rem;
          background: #f8fafc;
          border-radius: 8px;
        }

        .chat-icon {
          color: #3b82f6;
          font-size: 1.25rem;
        }

        // Expanded view styles
        .expanded-content {
          padding: 2rem;
        }

        .expanded-content h2 {
          text-align: center;
          color: #1e293b;
          font-size: 1.875rem;
          font-weight: 700;
          margin-bottom: 2rem;
          letter-spacing: -0.025em;
        }

        .consultation-grid {
          display: grid;
          grid-template-columns: 1.5fr 1fr;
          gap: 2rem;
          max-width: 1200px;
          margin: 0 auto;
        }

        @media (max-width: 900px) {
           .consultation-grid {
             grid-template-columns: 1fr;
             gap: 1.5rem;
           }
           .expanded-content {
             padding: 1.5rem;
           }
           .expanded-content h2 {
             font-size: 1.5rem;
             margin-bottom: 1.5rem;
           }
        }

        .chat-section {
          background: #fff;
          border: 1px solid #e2e8f0;
          border-radius: 16px;
          overflow: hidden;
        }

        .chat-header {
          padding: 1.5rem;
          border-bottom: 1px solid #e2e8f0;
        }

        .chat-header h3 {
          font-size: 1.25rem;
          font-weight: 600;
          color: #1e293b;
          margin: 0 0 0.5rem 0;
        }

        .chat-header p {
          color: #64748b;
          margin: 0;
          font-size: 0.875rem;
        }

        .message-thread {
          padding: 1.5rem;
          background: #f8fafc;
          min-height: 400px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }

        .message {
          display: flex;
          gap: 1rem;
          margin-bottom: 1.5rem;
        }

        .message-avatar {
          width: 40px;
          height: 40px;
          background: #eff6ff;
          border-radius: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #3b82f6;
        }

        .message-content {
          flex: 1;
          background: #fff;
          padding: 1rem;
          border-radius: 12px;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
        }

        .message-header {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          margin-bottom: 0.5rem;
        }

        .name {
          font-weight: 600;
          color: #1e293b;
        }

        .badge {
          font-size: 0.75rem;
          padding: 0.25rem 0.75rem;
          background: #eff6ff;
          color: #3b82f6;
          border-radius: 1rem;
        }

        .time {
          font-size: 0.75rem;
          color: #94a3b8;
          display: block;
          margin-top: 0.5rem;
        }

        .message-input {
          display: flex;
          gap: 0.75rem;
          margin-top: 1rem;
        }

        .message-input input {
          flex: 1;
          padding: 0.75rem 1rem;
          border: 1px solid #e2e8f0;
          border-radius: 8px;
          font-size: 0.875rem;
          transition: all 0.2s ease;
        }

        .message-input input:focus {
          outline: none;
          border-color: #3b82f6;
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
        }

        .send-btn {
          padding: 0.75rem;
          background: #3b82f6;
          color: white;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .send-btn:hover {
          background: #2563eb;
        }

        .doctors-section {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
        }

        .search-box {
          position: relative;
        }

        .search-icon {
          position: absolute;
          left: 1rem;
          top: 50%;
          transform: translateY(-50%);
          color: #94a3b8;
        }

        .search-box input {
          width: 100%;
          padding: 0.75rem 1rem 0.75rem 2.5rem;
          border: 1px solid #e2e8f0;
          border-radius: 8px;
          font-size: 0.875rem;
        }

        .doctors-list {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }

        .doctor-card {
          padding: 1rem;
          border: 1px solid #e2e8f0;
          border-radius: 12px;
          background: #fff;
          transition: all 0.2s ease;
        }

        .doctor-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
        }

        .doctor-card.available {
          border-color: #3b82f6;
          background: #eff6ff;
        }

        .doctor-info {
          display: flex;
          gap: 1rem;
          margin-bottom: 1rem;
        }

        .doctor-avatar {
          position: relative;
          width: 48px;
          height: 48px;
          background: #f8fafc;
          border-radius: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #64748b;
        }

        .status-dot {
          position: absolute;
          bottom: 0;
          right: 0;
          width: 12px;
          height: 12px;
          background: #22c55e;
          border: 2px solid #fff;
          border-radius: 50%;
        }

        .status-dot.busy {
          background: #94a3b8;
        }

        .doctor-info h4 {
          font-size: 1rem;
          font-weight: 600;
          color: #1e293b;
          margin: 0 0 0.25rem 0;
        }

        .doctor-info p {
          font-size: 0.875rem;
          color: #64748b;
          margin: 0 0 0.5rem 0;
        }

        .rating {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-size: 0.875rem;
        }

        .rating svg {
          color: #f59e0b;
        }

        .reviews {
          color: #94a3b8;
        }

        .consult-btn {
          width: 100%;
          padding: 0.75rem;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.5rem;
          background: #3b82f6;
          color: white;
          border: none;
          border-radius: 8px;
          font-size: 0.875rem;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .consult-btn:hover {
          background: #2563eb;
        }

        .consult-btn.secondary {
          background: #f1f5f9;
          color: #64748b;
        }

        .consult-btn.secondary:hover {
          background: #e2e8f0;
        }

        // Control button styles
        .control-btn {
          position: absolute;
          top: 0.75rem;
          right: 0.75rem;
          padding: 0.5rem;
          border: none;
          background: transparent;
          color: #94a3b8;
          cursor: pointer;
          transition: all 0.2s ease;
          border-radius: 6px;
        }

        .control-btn:hover {
          background: #f1f5f9;
          color: #64748b;
        }
      `}</style>
    </div>
  );
};

export default AskADoctor;